import { render, staticRenderFns } from "./FuncionarioForm.vue?vue&type=template&id=53fca9fc&scoped=true&lang=pug&"
import script from "./FuncionarioForm.vue?vue&type=script&lang=js&"
export * from "./FuncionarioForm.vue?vue&type=script&lang=js&"
import style0 from "./FuncionarioForm.vue?vue&type=style&index=0&id=53fca9fc&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fca9fc",
  null
  
)

export default component.exports